import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api';

const createOrGetArgoSession = async ()=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/login`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const invalidateArgoSession = async ()=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/logout`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const SessionRepository = {
  login: createOrGetArgoSession,
  logout: invalidateArgoSession
};